 <template>
  <div class="google-map">
    <!-- Initialized Map on this DIV -->
    <input
      id="pac-input"
      class="controls"
      type="text"
      placeholder="Search Map"
      @input="searchMap"
    />
    <v-btn @click="searchMap"> Search </v-btn>
    <div
      id="map"
      style="width: 100%; height: 300px"
      class="google-map"
      ref="googleMap"
    ></div>

    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot :google="google" :map="map" />
    </template>
  </div>
</template>
<script>
import GoogleMapsApiLoader from "google-maps-api-loader";

export default {
  async mounted() {
    const googleMapApi = await GoogleMapsApiLoader({
      libraries: ["places"],
      callback: "searchMap",
      apiKey: this.apiKey,
    });
    this.google = googleMapApi;
    this.initializeMap();
  },
  data() {
    return {
      google: null,
      map: null,
      search: "",
    };
  },
  props: {
    mapConfig: Object,
    apiKey: String,
  },
  methods: {
    // Initialize the Map on the DIV section
    initializeMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
    },
    // Search for Specific location
    async searchMap() { 
      const map = this.map;
      const input = document.getElementById("pac-input");
      const searchBox = new google.maps.places.SearchBox(input);
      //   map.controls[google.maps.ControlPosition.TOP_LEFT()].push(input);
      // Bias the SearchBox results towards current map's viewport.

      map.addListener("bounds_changed", () => {
        searchBox.setBounds(map.getBounds());
      });

      let markers = [];
      // Listen for the event fired when the user selects a prediction and retrieve
      // more details for that place.
      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();

        if (places.length == 0) {
          return;
        }
        // Clear out the old markers.
        markers.forEach((marker) => {
          marker.setMap(null);
        });
        markers = [];
        // For each place, get the icon, name and location.
        const bounds = new google.maps.LatLngBounds();
        places.forEach((place) => {
          if (!place.geometry) {
            console.log("Returned place contains no geometry");
            return;
          }
          const icon = {
            url: place.icon,
            size: new google.maps.Size(71, 71),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(17, 34),
            scaledSize: new google.maps.Size(25, 25),
          };
          // Create a marker for each place.
          markers.push(
            new google.maps.Marker({
              map,
              icon,
              title: place.name,
              position: place.geometry.location,
            })
          );
          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        map.fitBounds(bounds);
      });
    },
  }, 
};
</script>